import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { injectIntl, intlShape } from 'react-intl';
import { Panel } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { Button, Popover, Overlay } from 'react-bootstrap';
import Notes from './Notes.jsx';
import { inject, observer } from 'mobx-react';
import { NOTE_MAX_LENGTH } from './constants';

const isMobile = window.matchMedia('only screen and (max-width: 768px)')
  .matches;

@inject('rootStore')
@observer
class Lane extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newNote: false,
      newNoteText: '',
      showAddButton: false
    };

    this.canEdit = props.rootStore.authorizationStore.canUpdate;
  }

  render() {
    const { rootStore, intl, lane, hideAddNoteButton, ...props } = this.props;

    const { name, notesCount } = lane;

    const { formatMessage } = intl;

    const notes = lane.filteredNotes;

    return (
      <div {...props}>
        <Panel>
          <div className="lane-list-container">
            <div className="lane-header-container">
              <h4>
                <p className="lane-name">
                  {formatMessage({ id: lane.rootStore.boardType + '-' + name })}
                </p>
                <span className="notes-count badge">{notesCount}</span>

                <div className="lane-add-note" />
              </h4>
            </div>

            {this.renderNewNoteButton()}

            <Droppable
              droppableId={String(rootStore.lanes.indexOf(lane))}
              type={'LANE'}
            >
              {(provided, snapshot) => (
                <Notes
                  notes={notes}
                  lane={lane}
                  provided={provided}
                  snapshot={snapshot}
                />
              )}
            </Droppable>
          </div>
        </Panel>
      </div>
    );
  }

  renderNewNoteButton = () => {
    const {
      intl,
      hideAddNoteButton,
      rootStore: { isInclusiveBoard, dashboardType, boardId }
    } = this.props;
    const { newNote } = this.state;

    if (hideAddNoteButton) {
      return null;
    }

    // console.log('Edit: ', this.canEdit);

    if (newNote) {
      return this.renderNewNote();
    } else {
      return (
        <Button
          className="add-note-button"
          block
          bsStyle="default"
          onClick={this.showNewNote}
          disabled={!this.canEdit || this.props.rootStore.isInclusiveBoard}
        >
          {intl.formatMessage({
            id: !isInclusiveBoard
              ? 'add_a_card'
              : dashboardType === 'product'
              ? boardId != undefined
                ? 'select_a_feature'
                : 'select_a_mvp_or_feature'
              : 'select_a_bmc_or_section'
          })}
        </Button>
      );
    }
  };

  renderNewNote = () => {
    const formatMessage = this.props.intl.formatMessage;
    const tooLarge = this.state.newNoteText.length >= NOTE_MAX_LENGTH;

    return (
      <React.Fragment>
        <TextareaAutosize
          className="form-control new-note-form-control"
          type="text"
          autoFocus={true}
          onChange={this.onNewNoteChange}
          onKeyDown={this.checkKey}
          onBlur={this.finishEdit}
          value={this.state.newNoteText}
        />

        <Overlay
          show={this.state.showAddButton}
          target={this.inputRef}
          placement="top"
          container={this}
          containerPadding={10}
        >
          <Popover id="popover-contained" ref={this.inputRef}>
            <Button block bsStyle={'primary'} onClick={this.finishEdit}>
              {this.props.intl.formatMessage({ id: 'add_card_btn' })}
            </Button>
          </Popover>
        </Overlay>

        {tooLarge && (
          <div>
            <span className="fa fa-exclamation-circle" />
            {formatMessage({ id: 'note_text_too_large' })}
          </div>
        )}
      </React.Fragment>
    );
  };

  addNote = () => {
    const { lane } = this.props;
    const tooLarge = this.state.newNoteText.length >= NOTE_MAX_LENGTH;

    if (tooLarge) {
      return;
    }

    lane.addNote({ name: this.state.newNoteText });
    this.setState({ newNoteText: '' });
  };

  editName = (lane, name) => {
    if (name) {
      // LaneStore.editLane(lane, name);
    } else {
      // LaneStore.deleteLane(lane);
    }
  };

  loadMoreNotes = (lane, page) => {
    // LaneStore.loadMoreNotes.call(this, lane, page);
  };

  // ---------------- NewNote logic ----------------------------------

  showNewNote = e => {
    e.preventDefault();

    this.setState({ newNote: true });
  };

  hideNewNote = e => {
    e.preventDefault();

    this.setState({ newNote: false });
  };

  hideClearNewNote = e => {
    e.preventDefault();

    this.hideNewNote(e);
    this.setState({ newNoteText: '' });
  };

  onNewNoteChange = e => {
    e.preventDefault();

    this.setState({ newNoteText: e.target.value, showAddButton: true });
    //console.log('onNewNoteChange');
  };

  checkKey = e => {
    if (e.key === 'Tab') {
      this.setState({ newNoteText: e.target.value + '    ' });
      e.preventDefault();
    }

    if (e.key === 'Enter' && !e.shiftKey && !isMobile) {
      e.preventDefault();
      this.finishEdit(e);
    }

    if (e.key === 'Escape') {
      this.hideClearNewNote(e);
    }
  };

  finishEdit = e => {
    //console.log('finishEdit: ', e.target.value);
    if (e) {
      e.preventDefault();
    }
    //e.stopPropagation();

    if (this.state.newNoteText.trim()) {
      this.addNote();
    } else {
      this.hideClearNewNote(e);
    }

    this.setState({
      showAddButton: false
    });
  };

  // ----------------------------------------------------------------
}

Lane.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(Lane);
